/**
 * Estilo do mapa com alto contraste e leve tom SGU — foco em nitidez e legibilidade.
 */
export const MAP_DARK_STYLES = [
  {
    featureType: "all",
    elementType: "geometry",
    stylers: [{ saturation: 12 }, { lightness: 4 }],
  },
  { elementType: "geometry", stylers: [{ color: "#eef2eb" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }, { weight: 3 }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#2a3d34" }] },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{ color: "#9aab96" }, { weight: 1.2 }],
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [{ color: "#1c4220" }],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#243830" }],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#e6ece3" }],
  },
  {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [{ color: "#dce6d6" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#4a5c52" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#c8dbb8" }],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#3d5c32" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#b8c4b2" }, { weight: 0.8 }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#3d5248" }],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#fafcf9" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#f0f4ed" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#a8b8a0" }, { weight: 1 }],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#1c4220" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#8ec4dc" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#2a6070" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#ffffff" }, { weight: 2 }],
  },
];

export const MAP_VIEW_ROADMAP = "roadmap";
export const MAP_VIEW_SATELLITE = "satellite";

const getSavedMapView = () => {
  try {
    const saved = sessionStorage.getItem("mapViewType");
    return saved === MAP_VIEW_SATELLITE ? MAP_VIEW_SATELLITE : MAP_VIEW_ROADMAP;
  } catch {
    return MAP_VIEW_ROADMAP;
  }
};

export const getInitialMapViewType = () => getSavedMapView();

/** Aplica mapa customizado ou visão de satélite (híbrido com rótulos). */
export const applyMapViewType = (map, viewType) => {
  if (!map || !window.google?.maps) return;

  const { MapTypeId } = window.google.maps;

  if (viewType === MAP_VIEW_SATELLITE) {
    map.setMapTypeId(MapTypeId.HYBRID);
    map.setOptions({ styles: [], backgroundColor: "#1a2830" });
  } else {
    map.setMapTypeId(MapTypeId.ROADMAP);
    map.setOptions({ styles: MAP_DARK_STYLES, backgroundColor: "#eef2eb" });
  }
};

export const MAP_OPTIONS = {
  styles: MAP_DARK_STYLES,
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: true,
  zoomControl: true,
  clickableIcons: false,
  backgroundColor: "#eef2eb",
  mapTypeId: getSavedMapView() === MAP_VIEW_SATELLITE ? "hybrid" : "roadmap",
};
